export enum PublicTrackingEndpoint {
  Base = '/delivery-note-tracking',
  RequestNumber = 'requestNumber',
}
